import { render, staticRenderFns } from "./no-card-table-paginator.vue?vue&type=template&id=8755c284&"
import script from "./no-card-table-paginator.vue?vue&type=script&lang=js&"
export * from "./no-card-table-paginator.vue?vue&type=script&lang=js&"
import style0 from "./no-card-table-paginator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports